import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useToast } from 'components/ui/use-toast';
import * as Api from '../api';

// Generates or rotates the team's join link + code. Invalidates the cached
// token so the modal re-reads the freshly-minted credential.
const useGenerateJoinToken = () => {
  const queryClient = useQueryClient();
  const { toast } = useToast();

  return useMutation({
    mutationFn: async (teamId: string) => {
      const response = await Api.generateJoinToken(teamId);
      return response.data.data;
    },
    onSuccess: (_, teamId) => {
      queryClient.invalidateQueries({ queryKey: ['teams', 'join-token', teamId] });
    },
    onError: (error: any) => {
      toast.error('Error', {
        description: error?.response?.data?.message || 'Failed to generate join link',
      });
    },
  });
};

export default useGenerateJoinToken;
